module.exports = __webpack_public_path__ + "img/progressWaiting.c09aeaad.svg";